import React from 'react';
import { Person } from '@mui/icons-material';
import StatusWithText from './StatusWithText';

const ModalUserStatusCard = ({
  name,
  status = null,
  icon: Icon = Person,
  iconSize = 24,
  iconColor = "text-violet-700",
  backgroundColor = "bg-violet-100",
  containerClassName = "",
  nameClassName = "",
  initials = null
}) => {
  return (
    <div className={`bg-gray-50 rounded-xl px-6 py-4 ${containerClassName} `}>
      <div className={`flex ${status ? "items-start" : "items-center"}`}>
        <div
          className={`${backgroundColor} w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0`}
        >
          {initials ?
            <span className="text-white font-semibold">{initials}</span> :
            <div className={iconColor}>
              <Icon style={{ fontSize:iconSize, marginBottom: "2px" }} />
            </div>
          }
        </div>
        <div className="ml-4">
          <h3 className={`text-xl font-bold text-gray-900 ${nameClassName}`}>
            {name}
          </h3>
          {status && (
            <div className="mt-1">
              <StatusWithText status={status.toLowerCase()} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalUserStatusCard;
